import { Box } from '../Common/Box';
import { PaymentMethodEnum } from '@/types/common';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { getPaymentMethodLogoUrl } from '@/utils/paymentMethods';

export const IdealPayBox = () => {
  const {
    paymentMethodSelected,
    actions: { setPaymentMethodSelected },
  } = useContext(CheckoutContext);
  return (
    <Box
      isSelected={paymentMethodSelected === PaymentMethodEnum.IDEAL}
      onSelect={() => setPaymentMethodSelected(PaymentMethodEnum.IDEAL)}
    >
      <img src={getPaymentMethodLogoUrl(PaymentMethodEnum.IDEAL)} alt="ideal" />
    </Box>
  );
};
